<coin-v2-card
  styleVariant="large"
  padding="none">
  <div
    class="close-button smaller"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
  </div>
  <ngx-simplebar class="primary-scrollbar-vertical">
    <div class="inner-wrapper">
      <customer-org-tree-overview-item
        [head]="rootEmployee()"
        [service]="service()"
        [selectedEmployeeId]="selectedEmployeeId()"
        [customOpenEmployeeInViewAction]="customOpenEmployeeInViewAction()"
        [level]="0"
        [seasonId]="seasonId()"
        (clickTreeItem)="onClose()"></customer-org-tree-overview-item>
      <customer-org-tree-overview-items
        [rootEmployee]="rootEmployee()"
        [selectedEmployeeId]="selectedEmployeeId()"
        [customOpenEmployeeInViewAction]="customOpenEmployeeInViewAction()"
        [service]="service()"
        [level]="1"
        [seasonId]="seasonId()"
        (itemSelect)="onClose()"></customer-org-tree-overview-items>
    </div>
  </ngx-simplebar>
</coin-v2-card>
